<template>
    <transition name="slide">
        <div class="container-fluid fixed-top bg-white shadow">
            <div class="row">
                <div class="col-12 col-lg-10 col-xl-8 offset-lg-1 offset-xl-2 py-3">
                    <div class="d-none d-lg-flex justify-content-between px-4 px-lg-0">
                        <div>
                            <span class="number mr-2">{{ activeLink.number }}.</span>
                            pravilo spletne higiene:
                            <span class="rule">{{ activeLink.title }}</span>
                        </div>

                        <div>
                            <router-link :to="link.url" :class="{'mr-2': index !== notActiveLinks.length - 1}"
                                         v-for="(link, index) in notActiveLinks" :key="index">pravilo<span class="mx-1"><ArrowRight/></span>
                                <span class="number mr-2">{{ link.number }}.</span>
                            </router-link>
                        </div>
                    </div>

                    <div class="d-flex d-lg-none justify-content-between">
                        <div style="max-width: calc(100% - 60px);">
                            <div v-show="!hamburgerIsActive">
                                <span class="number">{{ activeLink.number }}.</span> pravilo:
                                <span class="rule text-truncate d-inline-block" style="vertical-align: middle">
                                    {{ activeLink.title }}
                                </span>
                            </div>
                        </div>
                        <div>
                            <button :class="['hamburger hamburger--spin', {'is-active': hamburgerIsActive}]"
                                    type="button"
                                    @click="hamburgerIsActive=!hamburgerIsActive">
                                <span class="hamburger-box">
                                    <span class="hamburger-inner"></span>
                                </span>
                            </button>
                        </div>
                    </div>

                    <div class="bg-white min-vh-100 fixed-top fixed-bottom hamburger-menu" v-show="hamburgerIsActive">
                        <HamburgerMenu/>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
	import ArrowRight from '@/svg/arrow-right.vue'
	import HamburgerMenu from "@/components/HamburgerMenu";

	export default {
		name: "FixedNavbar",
		components: {
			HamburgerMenu,
			ArrowRight
		},
		data() {
			return {
				hamburgerIsActive: false,
				rules: [
					{
						url: `/${process.env.VUE_APP_FIRST_RULE_URL}`,
						number: 1,
						title: "Naredi backup!"
					},
					{
						url: `/${process.env.VUE_APP_SECOND_RULE_URL}`,
						number: 2,
						title: "Ne verjemi velikim obljubam!"
					},
					{
						url: `/${process.env.VUE_APP_THIRD_RULE_URL}`,
						number: 3,
						title: "Za profilno sliko je lahko kdorkoli!"
					},
				],
				firstRuleUrl: `/${process.env.VUE_APP_FIRST_RULE_URL}`,
				secondRuleUrl: `/${process.env.VUE_APP_SECOND_RULE_URL}`,
				thirdRuleUrl: `/${process.env.VUE_APP_THIRD_RULE_URL}`,
			}
		},
		computed: {
			activeLink() {
				return this.rules.find(rule => rule.url === this.$route.path);
			},
			notActiveLinks() {
				return this.rules.filter(rule => rule.url !== this.$route.path);
			},
		},
		watch: {
			hamburgerIsActive(isActive) {
				if (isActive) {
					document.documentElement.classList.add('overflow-hidden');
					document.body.classList.add('overflow-hidden');
				} else {
					document.documentElement.classList.remove('overflow-hidden');
					document.body.classList.remove('overflow-hidden');
				}
			}
		},
	}
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/functions';
    @import '~bootstrap/scss/variables';
    @import '~bootstrap/scss/mixins';

    .rule {
        max-width: 65%;

        @include media-breakpoint-up(md) {
            max-width: 80%;
        }

        @include media-breakpoint-up(lg) {
            max-width: 100%;
        }
    }

    .slide-enter, .slide-leave-to {
        transform: translateY(-100%);
    }

    .slide-enter-active, .slide-leave-active {
        transition: all 250ms ease;
    }

    .hamburger-menu {
        z-index: -1;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
    }

    .number {
        $size: 25px;

        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: $size;
        height: $size;
        border-radius: 50%;
        font-weight: 500;
        color: #fff;
        background-color: #000;
    }

    .rule {
        font-weight: bold;
        text-decoration: underline;
        text-transform: uppercase;
    }

    a {
        color: #000000;

        &:hover {
            color: #000;
        }
    }

    /*!
     * Hamburgers
     * @description Tasty CSS-animated hamburgers
     * @author Jonathan Suh @jonsuh
     * @site https://jonsuh.com/hamburgers
     * @link https://github.com/jonsuh/hamburgers
     */
    .hamburger {
        display: inline-block;
        cursor: pointer;
        transition-property: opacity, filter;
        transition-duration: 0.15s;
        transition-timing-function: linear;
        font: inherit;
        color: inherit;
        text-transform: none;
        background-color: transparent;
        border: 0;
        margin: 0;
        overflow: visible;
    }

    .hamburger:hover {
        opacity: 0.7;
    }

    .hamburger.is-active:hover {
        opacity: 0.7;
    }

    .hamburger.is-active .hamburger-inner,
    .hamburger.is-active .hamburger-inner::before,
    .hamburger.is-active .hamburger-inner::after {
        background-color: #000;
    }

    .hamburger-box {
        width: 25px;
        height: 10px;
        display: inline-block;
        position: relative;
    }

    .hamburger-inner {
        display: block;
        top: 50%;
        margin-top: -2px;
    }

    .hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
        width: 20px;
        height: 2px;
        background-color: #000;
        border-radius: 2px;
        position: absolute;
        transition-property: transform;
        transition-duration: 0.15s;
        transition-timing-function: ease;
    }

    .hamburger-inner::before, .hamburger-inner::after {
        content: "";
        display: block;
    }

    .hamburger-inner::before {
        top: -5px;
    }

    .hamburger-inner::after {
        bottom: -5px;
    }

    /*
    * Spin
    */

    .hamburger--spin .hamburger-inner {
        transition-duration: 0.22s;
        transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }

    .hamburger--spin .hamburger-inner::before {
        transition: top 0.1s 0.25s ease-in, opacity 0.1s ease-in;
    }

    .hamburger--spin .hamburger-inner::after {
        transition: bottom 0.1s 0.25s ease-in, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }

    .hamburger--spin.is-active .hamburger-inner {
        transform: rotate(225deg);
        transition-delay: 0.12s;
        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    .hamburger--spin.is-active .hamburger-inner::before {
        top: 0;
        opacity: 0;
        transition: top 0.1s ease-out, opacity 0.1s 0.12s ease-out;
    }

    .hamburger--spin.is-active .hamburger-inner::after {
        bottom: 0;
        transform: rotate(-90deg);
        transition: bottom 0.1s ease-out, transform 0.22s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
    }
</style>